import { css, Theme } from '@emotion/react'
import { getColorOptions } from 'theme/utils'

export const buttonsWrapper = css`
  display: flex;
  column-gap: 5px;
`

export const arrowButton = (theme: Theme) =>
  css`
    width: 29px;
    height: 29px;
    padding: 0;

    color: ${getColorOptions(theme.colors.accent).main};

    background-color: ${getColorOptions(theme.colors.accent).soft};

    transition: none;

    :nth-of-type(1) {
      svg {
        transform: rotate(180deg);
      }
    }

    svg {
      width: 14px;
      height: 14px;
    }

    :disabled {
      color: #5a6c8a;

      background-color: #e6eaef;
    }
  `
